import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {AppComponent} from "./components/main/app.component";
import {SharedModule} from "./shared/shared.module";
import {RouterModule} from "@angular/router";
import {rootRouterConfig} from "./app.routes";
import {BrowserXhr} from "@angular/http";
import {CORSBrowserXHr} from "./services/CORs";
import {EndpointsService} from "./services/endpoints.service";
import {HttpApiService} from "./services/http-api.service";
import {ProfilesService} from "./services/profiles.service";
import {SharedService} from "./services/shared.service";
import {TenantService} from "./services/tenant.service";
import {UserService} from "./services/user.service";
import {SearchProfileService} from "./services/search-profile.service";
import {BuyerModule} from "./components/buyer/buyer.module";
import {BuyerAuthGuard} from "./components/buyer/buyer-auth-guard";
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import {NotificationService} from "./services/notification.service";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    BuyerModule,
    SharedModule,
    RouterModule.forRoot(rootRouterConfig)
  ],
  declarations: [
    AppComponent,
    PageNotFoundComponent
  ],
  providers: [
    {provide: BrowserXhr, useClass: CORSBrowserXHr},
    EndpointsService,
    HttpApiService,
    ProfilesService,
    SharedService,
    SearchProfileService,
    NotificationService,
    TenantService,
    UserService,
    BuyerAuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts